<div class="loader-container" [ngClass]="{ 'trans show': loaderService.showLoaderTrans$ | async}">
    <p>
        <img src="assets/images/gif/logo_card.png" alt="Loading" class="w-150-px max-w-100">
    </p>
    <!-- <div class="loader-box"></div> -->
</div>